// Events
import { CART_CHANGED, MODAL_CLOSED, MOUNT_COMPONENTS, THEME_CART_UPDATED } from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';
import { clear, hide, show, stringToNode } from 'utils/node';

/**
 * This component is the container of the upsell module(s). It handles rendering the upsell block
 */

export default component((node, ctx) => {
  const { closeButton, inner } = choozy(node);

  let preventRender = false;
  let addedToCart = 0;

  ctx.on(MODAL_CLOSED, (state, { id }) => {
    if (id !== 'cart') return;

    // If the user closed the upsell module, you can only show it again after the cart has been closed
    preventRender = false;
  });

  ctx.on(THEME_CART_UPDATED, async () => {
    if (preventRender) return;

    try {
      const response = await fetch(`${theme.endpoints.cart}?view=upsell-module`, { method: 'GET' });
      const text = await response.text();
      const upsellContent = stringToNode(text);

      if (upsellContent === null) {
        hide(node);
        node.classList.remove('is-loading');
        return;
      }

      // Prevent rendering the exact same upsell after cart updates
      if (
        inner.firstElementChild &&
        inner.firstElementChild.dataset.upsellId === upsellContent.dataset.upsellId
      ) {
        node.classList.remove('is-loading');
        return;
      }

      clear(inner);
      inner.appendChild(upsellContent);
      ctx.emit(MOUNT_COMPONENTS);

      show(node);
      node.classList.remove('is-loading');
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
    }
  });

  ctx.on(CART_CHANGED, () => {
    node.classList.add('is-loading');
  });

  node.addEventListener('product:form:submit', () => {
    addedToCart += 1;

    if (addedToCart >= 2) {
      preventRender = true;
      hide(node);
    }
  });

  closeButton.addEventListener('click', () => {
    preventRender = true;

    hide(node);
  });
});
